var map = {
	"./ADYG.png": "d901",
	"./ALAN.png": "c689",
	"./ALTAYR.png": "d959",
	"./ALTK.png": "17db",
	"./AMUR.png": "362e",
	"./ARKHAN.png": "262f",
	"./ASTRA.png": "3576",
	"./BASHK.png": "37d7",
	"./BELG.png": "a733",
	"./BRYANSK.png": "3a9c",
	"./BURYAT.png": "bce7",
	"./CHECHEN.png": "f768",
	"./CHEL.png": "fccd",
	"./CHUKOT.png": "ba34",
	"./CHUVASH.png": "4942",
	"./DAGEST.png": "6968",
	"./EVREY.png": "496c",
	"./HABAR.png": "2132",
	"./HAKAS.png": "f3e3",
	"./HANTI.png": "07ac",
	"./INGUSH.png": "4f81",
	"./IRKUT.png": "8dba",
	"./IVAN.png": "c637",
	"./KABARD.png": "e2d3",
	"./KALIN.png": "402b",
	"./KALM.png": "8d16",
	"./KALUG.png": "b982",
	"./KAMCH.png": "8078",
	"./KARACH.png": "55d4",
	"./KAREL.png": "e24f",
	"./KEMER.png": "39d7",
	"./KIROV.png": "761e",
	"./KOMY.png": "ccc7",
	"./KOSTR.png": "5a51",
	"./KRASNODAR.png": "8164",
	"./KRAYARSK.png": "873f",
	"./KRIM.png": "849a",
	"./KURGAN.png": "c93a",
	"./KURSK.png": "55e2",
	"./LENIN.png": "1534",
	"./LIP.png": "53f7",
	"./MAGADAN.png": "1944",
	"./MARIY.png": "8cb1",
	"./MORDOV.png": "1470",
	"./MOSOBL.png": "c5a9",
	"./MURM.png": "4848",
	"./NENEZ.png": "fe2f",
	"./NIZHEG.png": "f0a9",
	"./NOVG.png": "804c",
	"./NOVOSIB.png": "6150",
	"./OMSK.png": "974c",
	"./ORENBUR.png": "30d9",
	"./ORLOV.png": "c081",
	"./PENZ.png": "ec93",
	"./PERM.png": "20a5",
	"./PRIMOR.png": "6730",
	"./PSKOV.png": "f3c0",
	"./ROSTOV.png": "46bf",
	"./RYAZ.png": "ae7d",
	"./SAHA.png": "0bc9",
	"./SAHAL.png": "8bc6",
	"./SAMAR.png": "1831",
	"./SARAT.png": "e7f6",
	"./SEVAS.png": "5eea",
	"./SMOLENSK.png": "1e73",
	"./SPB.png": "c81c",
	"./STAVR.png": "61bf",
	"./SVERDL.png": "da31",
	"./TAMBOV.png": "460e",
	"./TATAR.png": "8f2f",
	"./TIVA.png": "4166",
	"./TOMSK.png": "7924",
	"./TULSK.png": "4fd1",
	"./TUMEN.png": "23a1",
	"./TVER.png": "a67f",
	"./UDMUR.png": "ca98",
	"./ULYAN.png": "1d0f",
	"./VLADIM.png": "7d3d",
	"./VOLG.png": "d140",
	"./VOLOGOD.png": "d189",
	"./VORON.png": "fa23",
	"./YANAO.png": "6363",
	"./YAROSL.png": "3f57",
	"./ZABAY.png": "1ce3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "77e3";